import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const DepositCategoryEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("=== DepositCategoryEdit useEffect started ===");
    console.log("ID from params:", id);
    
    // Check authentication first
    const token = localStorage.getItem('token');
    console.log("Token from localStorage:", token ? "Token exists" : "No token found");
    
    if (!token) {
      console.log("No authentication token found, redirecting to login");
      navigate('/login');
      return;
    }

    setLoading(true);
    console.log("Making API call to:", `/accounts/deposit-categories/${id}`);
    
    Http.get(`/accounts/deposit-categories/${id}`)
      .then((res) => {
        console.log("=== API Response Success ===");
        console.log("Full response:", res);
        console.log("Response data:", res.data);
        
        // Check if the response has the expected structure
        if (res.data && (res.data.data || res.data.id)) {
          const data = res.data.data || res.data; // Handle both response formats
          console.log("Raw data from API:", data);
          
          // Transform numeric status to string format for the form
          const transformedData = {
            ...data,
            status: data.status === 1 ? "Active" : "Inactive"
          };
          console.log("Transformed data:", transformedData);
          
          setInputs(transformedData);
          console.log("Data set to inputs state");
        } else {
          console.error("Unexpected response structure:", res.data);
        }
      })
      .catch((error) => {
        console.error("=== API Error ===");
        console.error("Full error:", error);
        console.error("Error response:", error.response);
        console.error("Error status:", error.response?.status);
        console.error("Error data:", error.response?.data);
        
        // Handle authentication errors
        if (error.response?.status === 401) {
          console.log("Authentication failed, removing token and redirecting to login");
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          navigate('/login');
        }
      })
      .finally(() => {
        setLoading(false);
        console.log("=== API call completed, loading set to false ===");
      });
  }, [id, navigate]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    setLoading(true);
    // Transform string status back to numeric for backend
    const dataToSubmit = {
      ...inputs,
      status: inputs.status === "Active" ? 1 : 0
    };
    Http.put(`/accounts/deposit-categories/${id}`, dataToSubmit)
      .then((res) => {
        navigate("/deposit-categories", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Deposit Category</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Category Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>Category Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Enter Category Name"
                    />
                    <small className="text-muted">Current value: {JSON.stringify(inputs.name)}</small>
                  </div>
                  <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={inputs.status || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    <small className="text-muted">Current value: {JSON.stringify(inputs.status)}</small>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                      placeholder="Enter Description"
                      rows="3"
                    ></textarea>
                    <small className="text-muted">Current value: {JSON.stringify(inputs.description)}</small>
                  </div>
                </div>

                {/* <div className="row mt-3">
                  <div className="col-12">
                    <div className="alert alert-info">
                      <strong>Debug Info:</strong><br/>
                      Inputs state: {JSON.stringify(inputs, null, 2)}<br/>
                      Loading: {loading.toString()}
                    </div>
                  </div>
                </div> */}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <span>
                          <i className="fa fa-spinner fa-spin"></i> Updating...
                        </span>
                      ) : (
                        <span>
                          <i className="fa fa-save mg-r-10"></i> Update
                        </span>
                      )}
                    </button>
                  </div>
                  <div className="col-3">
                    <button
                      className="btn btn-secondary btn-block mg-b-10"
                      onClick={() => navigate('/deposit-categories')}
                      disabled={loading}
                    >
                      <i className="fa fa-arrow-left mg-r-10"></i> Back to List
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositCategoryEdit;